import React, { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom';
import { useGetPublicsubjectQuery } from '../../slices/teachers/subjectApiSlice';
import { useGetPublicplansQuery } from '../../slices/teachers/planApiSlice';
import { usePublicTeacherimageQuery } from '../../slices/teachers/teachersApiSlice';
import { Button }  from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import PublicPlan from '../../components/PublicPlan';

const TeacherPublicSubject = () => {

    const { id } = useParams();

    const myRef = useRef(null)

    const executeScroll = () => {
        myRef.current.scrollIntoView()    
    }

    const { data, error, isLoading } = useGetPublicsubjectQuery(id);

    const { data: teacherData, isTeacherLoading, isTeachererror, } = usePublicTeacherimageQuery(data?.teacher);

    const { data: plansData, error: plansError, isLoading: plansIsLoading } = useGetPublicplansQuery(id);
    
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [jobtitle, setJobtitle] = useState('');
    const [subtopics, setSubtopics] = useState('');
    const [picture, setPicture] = useState('');
    const [paysetup, setPaysetup] = useState('');
    const [isCoursePublish, setIsCoursePublish] = useState('');

    useEffect(() => {
        setTitle(data?.tittle);
        setDescription(data?.description);
        setFirstname(data?.firstname);
        setLastname(data?.lastname);
        setJobtitle(data?.jobtitle);
        setSubtopics(data?.subtopics);
        setIsCoursePublish(data?.isCoursePublish);
    }, [data?.tittle, data?.description, data?.firstname, data?.lastname, data?.jobtitle, data?.subtopics]);

    useEffect(() => {
        setPicture(teacherData?.image);    
        setPaysetup(teacherData?.isPaymentSetup);    
    }, [teacherData?.image]);

  return (
    <div className="bg-default2 ">
        <nav id="navbar-main" className="navbar navbar-horizontal navbar-transparent navbar-main navbar-expand-lg navbar-light navPubpro">
            <div className="container">
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="navbar-collapse navbar-custom-collapse collapse" id="navbar-collapse">
                    <div className="navbar-collapse-header">
                    <div className="row">
                        <div className="col-6 collapse-close">
                        <button type="button" className="navbar-toggler" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
                            <span></span>
                            <span></span>
                        </button>
                        </div>
                    </div>
                    </div>
                    <ul className="navbar-nav ">
                    <li className="nav-item">
                        <a href="../../pages/dashboards/dashboard.html" className="nav-link">
                        {/* <span className=" logP">ASK TO LEARN</span> */}
                        <span className=" logP" style={{textTransform: 'capitalize'}}>ask {firstname} {lastname}</span>

                        
                        </a>
                    </li>                    
                    </ul>
                    <hr className="d-lg-none" />
                    <ul className="navbar-nav align-items-lg-center ml-lg-auto">
                    <li className="nav-item">
                        <LinkContainer to="/studentlogin" className=''>
                            <span className="nav-link nav-link-icon">Login</span>
                        </LinkContainer >
                    </li>
                    <li className="nav-item">
                        <LinkContainer to="/studentregister" className=''>
                            <span className="nav-link nav-link-icon">Register</span>
                        </LinkContainer >
                    </li>                    
                    </ul>
                </div>
            </div>
        </nav> 
        <div className="main-content maincont2 " >
            <div className="container-fluid mt--5 loginResponsive ">
                <div className="header  py-5 py-lg-6 pt-lg-7">
                </div> 
                <div className="container mt--10 pb-5 containerP ">
                        {isLoading ? ( 
                                <Loader /> 
                            ) : error ? ( 
                                <Message variant='danger'>
                                    {error?.data?.message || error.error}
                                </Message> ) 
                                : (
                                <>    
                                    <div className="row bg-gradient-primary titleContainerP prof251">
                                        <div className=" offset-lg-1 col-lg-5 text-center titleContainerP2 prof111">
                                            <h1 className="display-5 text-white nameP2 text-center" style={{textTransform: 'capitalize'}}>{title}</h1>
                                            <p className="text-white mt-0 mb-7 titleP text-center" >
                                            {description}
                                            </p>                              
                                            <h6 className=" text-white TextS text-center PimageS2">Teacher</h6>
                                            { picture != 'none'  ? (
                                            <LinkContainer to={`/teacherpublicprofile/${data.user}`}>
                                                <img 
                                                src={`https://bucketeer-f3a53e81-2e13-49e9-82ca-c504e025aced.s3.amazonaws.com/public/profiles/${picture}`} 
                                                className="PimageS  PimageS2" 
                                                />
                                            </LinkContainer>
                                            ) : (
                                                <LinkContainer to={`/teacherpublicprofile/${data.user}`}>
                                                <img src={`https://static.thenounproject.com/png/4154905-200.png`} className="PimageS  PimageS2" />
                                            </LinkContainer>
                                            )}
                                            <LinkContainer to={`/teacherpublicprofile/${data.user}`}>
                                            <h5 className=" text-white TextSS text-center PimageS2" style={{textTransform: 'capitalize'}}>{firstname} {lastname}</h5>
                                            </LinkContainer>

                                        </div>
                                        <div className="col-lg-6">
                                            <div className="card-profile-image profileImg">
                                            <div className="imageS2">
                                                {data?.mediaId != 'none' ?  (
                                                <video controls className="imageS33">      
                                                    <source 
                                                        src={`https://bucketeer-f3a53e81-2e13-49e9-82ca-c504e025aced.s3.amazonaws.com/public/subjects/${data?.mediaId}`} 
                                                        type="video/mp4"
                                                    />
                                                 </video>
                                                ) : (
                                                <video controls className="imageS33">      
                                                    <source 
                                                        src={`https://bucketeer-f3a53e81-2e13-49e9-82ca-c504e025aced.s3.amazonaws.com/public/661563aa5faa226e359b0021IKMlmWs=.mp4`} 
                                                        type="video/mp4"
                                                    />
                                                </video>
                                                )}
                                            </div>                          
                                            <Button href="#!" className="btn btn-danger btnP9" onClick={executeScroll}>                                                
                                                Ask me a Question
                                            </Button>
                                            </div>
                                        </div>
                                    </div> 
                                    <div className="row bg-gradient-defaultt publicq2">
                                        <div className="text-center col-lg-4  aboutaskP"> <br /><br /> <br /><br />
                                        <h3 className="display-5 text-white">What you can ask me about:</h3><br /><br />
                                        </div>
                                    </div>
                                    <div className="row publicq bg-gradient-defaultt subtopc2">
                                        {subtopics?.subtopic1 &&
                                        <div className=" col-lg-3  aboutP">
                                            <p className="text-white askS">
                                            <span className="icon icon-shape  text-white rounded-circle shadow  bg-gradient-info">
                                            <i className="ni ni-check-bold"></i>
                                            </span>
                                            <span className="subtopicP">
                                                {subtopics?.subtopic1} 
                                            </span>
                                            </p>    
                                        </div>
                                        }
                                        {subtopics?.subtopic2 &&
                                        <div className=" col-lg-3  aboutP">
                                            <p className="text-white askS">
                                            <span className="icon icon-shape  text-white rounded-circle shadow bg-gradient-info">
                                            <i className="ni ni-check-bold"></i>
                                            </span>
                                            <span className="subtopicP">
                                                {subtopics?.subtopic2} 
                                            </span>
                                            </p>    
                                        </div>
                                        }
                                        {subtopics?.subtopic3 &&
                                        <div className=" col-lg-3  aboutP">
                                            <p className="text-white askS">
                                            <span className="icon icon-shape  text-white rounded-circle shadow bg-gradient-info">
                                            <i className="ni ni-check-bold"></i>
                                            </span>
                                            <span className="subtopicP">
                                                {subtopics?.subtopic3} 
                                            </span>
                                            </p>    
                                        </div>
                                        }
                                        {subtopics?.subtopic4 &&
                                        <div className=" col-lg-3  aboutP">
                                            <p className="text-white askS">
                                            <span className="icon icon-shape  text-white rounded-circle shadow bg-gradient-info">
                                            <i className="ni ni-check-bold"></i>
                                            </span>
                                            <span className="subtopicP">
                                                {subtopics?.subtopic4} 
                                            </span>
                                            </p>    
                                        </div>
                                        }
                                        {subtopics?.subtopic5 &&
                                        <div className=" col-lg-3  aboutP">
                                            <p className="text-white askS">
                                            <span className="icon icon-shape  text-white rounded-circle shadow bg-gradient-info">
                                            <i className="ni ni-check-bold"></i>
                                            </span>
                                            <span className="subtopicP">
                                                {subtopics?.subtopic5} 
                                            </span>
                                            </p>    
                                        </div>
                                        }
                                        {subtopics?.subtopic6 &&
                                        <div className="col-lg-3  aboutP">
                                            <p className="text-white askS">
                                            <span className="icon icon-shape  text-white rounded-circle shadow bg-gradient-info">
                                            <i className="ni ni-check-bold"></i>
                                            </span>
                                            <span className="subtopicP">
                                                {subtopics?.subtopic6} 
                                            </span>
                                            </p>    
                                        </div>
                                        }
                                        {subtopics?.subtopic7 &&
                                        <div className=" col-lg-3  aboutP">
                                            <p className="text-white askS">
                                            <span className="icon icon-shape  text-white rounded-circle shadow bg-gradient-info">
                                            <i className="ni ni-check-bold"></i>
                                            </span>
                                            <span className="subtopicP">
                                                {subtopics?.subtopic7} 
                                            </span>
                                            </p>    
                                        </div>
                                        }
                                        {subtopics?.subtopic8 &&
                                        <div className=" col-lg-3  aboutP">
                                            <p className="text-white askS">
                                            <span className="icon icon-shape  text-white rounded-circle shadow bg-gradient-info">
                                            <i className="ni ni-check-bold"></i>
                                            </span>
                                            <span className="subtopicP">
                                                {subtopics?.subtopic8} 
                                            </span>
                                            </p>    
                                        </div>
                                        }
                                        { subtopics?.subtopic9 &&
                                            <div className="col-lg-3  aboutP">
                                                <p className="text-white askS">
                                                <span className="icon icon-shape  text-white rounded-circle shadow bg-gradient-info">
                                                <i className="ni ni-check-bold"></i>
                                                </span>
                                                <span className="subtopicP">
                                                    {subtopics?.subtopic9} 
                                                </span>
                                                </p>    
                                            </div>
                                        } 
                                    <br /><br /><br /><br /><br /><br /><br /></div>                            
                                    <div className="row bg-gradient-default">
                                        <div className="offset-lg-1 col-lg-10 aboutP "><br />
                                            <div className="section_title22 text-center text-white mb-100 "><br /><br /><br /><br />
                                                <h2 className='text-white display-5 textCard44 '>
                                                <span className='discoverText'>
                                                    { isCoursePublish &&
                                                    <>
                                                     You can watch <span style={{textTransform: 'capitalize'}}>{title} </span> course  and&nbsp;  <br className='brr2' />
                                                     </>
                                                    }
                                                     You can send   
                                                      <span className="" style={{textTransform: 'capitalize'}}> {firstname} {lastname} </span>
                                                     video questions                                                                                                 
                                                <br />
                                                </span>
                                                </h2>                        
                                            </div>
                                            <br /><br /><br /><br /><br /><br /><br />
                                            <div className="row">
                                                <div className="col-xl-6 col-lg-6">
                                                    <div className="single_about_info text-white">
                                                        <h2 className='text-white display-3 '>
                                                            <span className='profileBigt profileBigt2'>Record your screen or camera to
                                                        <br className='brr3' />  send questions to your teacher</span></h2>
                                                        <p className='Feature11'>
                                                            If you get stuck while studying 
                                                            you can record your screen or camera to show your teacher exactly what you need help with
                                                            
                                                            </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6  col-lg-6">
                                                    <img src="../../assets/img/landing.png" className="explainerImg5 explainerImg55"  />
                                                </div>
                                            </div><br /><br /><br /><br /><br /><br /><br /><br />
                                            <div className="row">
                                                <div className="col-xl-6  col-lg-6">
                                                    <img src="../../assets/img/landing4.png" alt="" className="explainerImg4"   />
                                                </div>
                                                <div className="col-xl-6 col-lg-6">
                                                    <div className="single_about_info text-white">
                                                        <h2 className='text-white display-3'>
                                                            <span className='profileBigt profileBigt3 profileBigt33'>
                                                            Your teacher recieves your question                                                         
                                                        </span>
                                                        </h2>
                                                        <p className='Feature111'>
                                                            Your teacher will receive a notification every time that you send questions
                                                            your teacher will record his screen or camera and send you the answer                                                          
                                                        </p>
                                                    </div>
                                                </div>
                                            </div><br /><br /><br /><br /><br /><br /><br /><br />
                                            <div className="row">
                                                <div className="col-xl-6 col-lg-6">
                                                    <div className="single_about_info text-white">
                                                        <h2 className='text-white display-3'>
                                                        <span className='profileBigt profileBigt3 profileBigt34'>
                                                            Watch the answer from your teacher 
                                                        </span>
                                                             </h2>
                                                        <p className='Feature111 Feature143'>
                                                            You will receive a notification every time you get a  new answer from your teacher 
                                                            the answers will be save in your account if you neeed to watch it several times
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6  col-lg-6">
                                                    <img src="../../assets/img/landing2.png" alt="" className="explainerImg5 explainerImg56"   />
                                                </div>
                                            </div><br /><br /><br /><br /><br /><br /><br />                                             
                                        </div>
                                        </div>
                                        <div className="row bg-gradient-primary "> 
                                            <div className="offset-lg-1 col-lg-10 aboutP"><br /><br /><br /><br />
                                                <div className="section_title22 text-center text-white mb-100">
                                                    <h2 className='text-white display-5 chooseT chooseT3' ref={myRef}>
                                                    Choose the best plan for your learning <br />
                                                    <br />
                                                    </h2>                     
                                                </div>
                                            </div>                                            
                                            <div className="row justify-content-center">
                                                <div className="col-xl-12 ">
                                                    <div className="pricing   chooseT2">
                                                        {plansIsLoading ? ( 
                                                            <Loader />
                                                        ) : plansError ? (
                                                            <Message variant='danger'>
                                                                {error?.data?.message || error.error}
                                                            </Message>
                                                        ) : (
                                                            <div className="row "  >
                                                                {plansData?.map((plan) => (
                                                                    <div key={plan._id} className="col-md-6  col-xl-4 pricecard chooseT ">
                                                                        <PublicPlan plan={plan} paysetup={paysetup} isCoursePublish={isCoursePublish}  />
                                                                        <br /><br />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}                                             
                                                    </div><br /><br /><br /><br /><br />
                                                </div>
                                            </div>                                        
                                        </div>
                                </>
                            )}
                </div>
                <footer className="publicFooter2 "> 
                            <div className="container ">
                                <div className="row align-items-center alignFoot  ">
                                    <div className="col-xl-6">
                                    <div className="copyright text-center text-xl-left text-muted publicFooter">
                                      <span className='text-white'> 
                                         &copy; 2025</span> <a  className="font-weight-bold ml-1 text-white" target="_blank">Ask to Learn</a>
                                    </div>
                                    </div>
                                    <div className="col-xl-6 ">
                                        <ul className="nav nav-footer justify-content-center justify-content-xl-end publicFooter">
                                            <li className="nav-item">
                                            <a  className="nav-link text-white" >Categories</a>
                                            </li>
                                            <li className="nav-item">
                                            <a  className="nav-link text-white" target="_blank">About Us</a>
                                            </li>
                                            <li className="nav-item">
                                            <a  className="nav-link text-white" target="_blank">Blog</a>
                                            </li><br />
                                            <li className="nav-item">
                                            <a  className="nav-link text-white" target="_blank">License</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                </footer>
            </div>       
        </div>
    </div>
  )
}

export default TeacherPublicSubject
